/**
 * Format a "last seen" timestamp for chat headers / profile panels.
 * Always shows a concrete time so the user can see exactly when the
 * other party was last online — matches Telegram's "last seen today
 * at 18:09" / "last seen yesterday at 09:42" style.
 */
export function formatLastSeen(input?: string | Date | null): string {
  if (!input) return 'last seen recently'
  const date = typeof input === 'string' ? new Date(input) : input
  if (Number.isNaN(date.getTime())) return 'last seen recently'

  const now = new Date()
  const time = date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })

  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate()
  if (sameDay) return `last seen today at ${time}`

  const yesterday = new Date(now)
  yesterday.setDate(yesterday.getDate() - 1)
  const isYesterday =
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate()
  if (isYesterday) return `last seen yesterday at ${time}`

  const diffDays = Math.floor((now.getTime() - date.getTime()) / (24 * 60 * 60 * 1000))
  if (diffDays < 7) {
    const weekday = date.toLocaleDateString(undefined, { weekday: 'short' })
    return `last seen ${weekday} at ${time}`
  }

  const md = date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' })
  return `last seen ${md} at ${time}`
}
